// Per-market constants for the customer pages. The market comes from the
// hostname (*.co.uk → UK, anything else → AU), the same rule as the order app
// and the backend's link builders.

export const MARKET = window.location.hostname.endsWith(".co.uk") ? "UK" : "AU";

const MARKETS = {
  AU: {
    website: "https://tapestodigital.com.au",
    logo: "https://tapestodigital.com.au/hubfs/logo_tapes_todigital%202.svg",
    phoneDisplay: "+61 485 031 678",
    phoneTel: "+61485031678",
    whatsapp: "61485031678",
    order: "https://order.tapestodigital.com.au",
    // vue-tel-input country
    phoneCountry: "AU",
    // "From $24 a tape" — shown on the booking and photo-quote side cards
    priceFrom: "$24",
    // Legal entity in the footer
    company: "Pinns Solutions Pty Ltd",
  },
  UK: {
    website: "https://tapestodigital.co.uk",
    logo: "https://tapestodigital.co.uk/hubfs/logo_tapes_todigital%202.svg",
    phoneDisplay: "+44 7361 588591",
    phoneTel: "+447361588591",
    whatsapp: "447361588591",
    order: "https://order.tapestodigital.co.uk",
    phoneCountry: "GB",
    priceFrom: "£13",
    company: "Tape Conversions Pvt Ltd",
  },
};

export const market = MARKETS[MARKET];

// Website pages linked from the footer
export const websiteUrl = (path = "/") => `${market.website}${path}`;

// The customer's order link (HubSpot booking_items_link). VUE_APP_URL_ORDER
// overrides the origin for dev/staging.
export function orderUrl(token, path = "") {
  const origin = process.env.VUE_APP_URL_ORDER || market.order;
  return `${origin.replace(/\/$/, "")}/${encodeURIComponent(token)}${path}`;
}
